import { render, staticRenderFns } from "./CMAttachmentsPage.vue?vue&type=template&id=019a7d22&scoped=true&"
import script from "./CMAttachmentsPage.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsPage.vue?vue&type=style&index=0&id=019a7d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a7d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019a7d22')) {
      api.createRecord('019a7d22', component.options)
    } else {
      api.reload('019a7d22', component.options)
    }
    module.hot.accept("./CMAttachmentsPage.vue?vue&type=template&id=019a7d22&scoped=true&", function () {
      api.rerender('019a7d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/CMAttachmentsPage.vue"
export default component.exports